import gql from 'graphql-tag'

const mutation = gql`mutation forgotPassword ($input: ResetPasswordInput!){
  resetPassword (resetPasswordInput: $input){
    validityPeriod
  },
}`
export default mutation
